import { Box, Typography } from '@mui/material';
import DriverPickupsListing from './driver-pickups-listing/driver-pickups-listing';

function DriverPickups() {
  return (
    <div>
      <Box>
        <Typography
          variant="h3"
          component="h3"
          sx={{ textAlign: 'center', mt: 3, mb: 0 }}
        >
          Pickups
        </Typography>
        <br />
        <DriverPickupsListing />
      </Box>
    </div>
  );
}

export default DriverPickups;
